import React, { useContext, useEffect, useState } from "react";
import Select from "react-select";
import { AuthContext, LoaderContext } from "../../Context/ContextFunctions";
import SuccessModal from "../../components/common/SuccessModal";
import { ERROR_MESSAGES } from "../../components/common/GlobalMassssage";
import { AddUpdateDivisionalCategory } from "../../services/Divisional Category/DivisionalCategoryApi";
import { GetJobStatusLookupList } from "../../services/Job/JobApi";

const JobStatusDialog = ({ open, onClose, tender, userKeyID, onSubmit }) => {
    const [jobStatusID, setJobStatusID] = useState(null);
    const [jobChangeStatusRemark, setJobChangeStatusRemark] = useState(null);
    const [requireErrorMessage1, setRequireErrorMessage1] = useState(false);
    const [requireErrorMessage2, setRequireErrorMessage2] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [showSuccess, setShowSuccess] = useState(false);
    const [statusList, setStatusList] = useState([]);

    useEffect(() => {
        async function fetchData() {
            // const res = await GetJobStatus
            try {
                // let response = await GetCountryLookupList();
                let response = await GetJobStatusLookupList();

                // Check if response contains data
                if (response?.statusCode === 200) {
                    const zoneDivisionalOptions = response?.responseData?.data.map((item) => ({
                        value: item.jobStatusID,
                        label: item.jobStatusName,
                    }));
                    // Confirm correct mapping

                    setStatusList(zoneDivisionalOptions);
                } else {
                    console.warn("Unexpected API response structure", response);
                }
            } catch (error) {
                console.error("Error fetching zone divisional lookup list:", error);
            }

        }
        fetchData()
    }, [])

    useEffect(() => {
        setRequireErrorMessage1(false)
        setRequireErrorMessage2(false)
        if (open && tender) {
            const selectedStatus = statusList.find(
                (x) => x.value === tender?.jobStatusID
            );

            setJobStatusID(selectedStatus || null);
            setJobChangeStatusRemark(tender?.jobChangeStatusRemark ?? "");
        }
    }, [open, tender]);


    const handleSubmit = () => {
        if (
            jobStatusID === undefined ||
            jobStatusID === null ||
            jobStatusID === ""
        ) {
            setRequireErrorMessage1(true);
            return
        }
        if (jobStatusID?.value === 4 &&
            (jobChangeStatusRemark === undefined ||
                jobChangeStatusRemark === null ||
                jobChangeStatusRemark?.trim() === "")
        ) {
            setRequireErrorMessage2(true);
            return
        }
        onSubmit({
            jobStatusID: jobStatusID,   // whatever field you use
            jobChangeStatusRemark: jobChangeStatusRemark,               // textarea value
        });
    };


    return (
        open && (
            <>
                <div className="fixed inset-0 flex items-center justify-center z-50">

                    {/* Overlay */}
                    <div className="fixed inset-0 bg-black opacity-50" onClick={onClose}></div>

                    {/* Dialog */}
                    {/* <div className="fixed inset-0 flex items-center justify-center z-50"> */}
                    <div className="bg-white rounded-lg shadow-lg z-10 w-[90%] sm:w-[60%] md:w-[40%] lg:w-[30%] max-h-[90vh] flex flex-col text-sm">
                        <div className="bg-[#ECF6FF] px-6 py-4 border-b flex justify-between items-center">
                            <h2 className="text-lg font-semibold">Update Status</h2>
                            <button
                                className="text-gray-500 hover:text-gray-900"
                                onClick={onClose}
                            >
                                ✕
                            </button>
                        </div>
                        <div className="flex-1 p-4" >
                            {/* Status */}
                            <label className="block text-sm font-medium">Status <span style={{ color: "red" }}>*</span>    </label>
                            <Select
                                options={statusList}
                                value={jobStatusID}
                                onChange={(option) => {
                                    setJobStatusID(option);
                                    setRequireErrorMessage1(false)
                                }}
                            />
                            {requireErrorMessage1 &&
                                (
                                    <label className="validation">{ERROR_MESSAGES}</label>
                                )}
                        </div>
                        {/* Remark */}
                        {jobStatusID?.value == 4 && (
                            <div className="flex-1 p-4">
                                <label className="block text-sm font-medium">Remark <span style={{ color: "red" }}>*</span> </label>
                                <textarea
                                    rows={3}
                                    className="w-full border p-2 rounded"
                                    value={jobChangeStatusRemark}
                                    onChange={(e) => { setJobChangeStatusRemark(e.target.value); setRequireErrorMessage2(false) }}
                                />
                                {requireErrorMessage2 &&
                                    (
                                        <label className="validation">{ERROR_MESSAGES}</label>
                                    )}
                            </div>
                        )}

                        {errorMessage && (
                            <p className="text-red-600 text-center mt-2 text-sm">{errorMessage}</p>
                        )}

                        {/* Footer Buttons */}
                        <div className="bg-gray-50 px-6 py-4 rounded-b-lg border-t flex justify-end gap-3">
                            <button
                                className="px-4 py-2 bg-gray-300 rounded-md text-12"
                                onClick={onClose}>
                                Cancel
                            </button>
                            <button
                                className="bg-gradient-to-r from-[#0E4C84] to-[#00A7C1] hover:from-[#135EA0] hover:to-[#00B8D4] text-white px-5 py-2 rounded-lg text-12 font-medium shadow-md shadow-cyan-500/30 hover:shadow-cyan-400/40 transition-all duration-300"
                                onClick={handleSubmit}
                            >
                                Update
                            </button>
                        </div>



                        <SuccessModal
                            isOpen={showSuccess}
                            onClose={() => {
                                setShowSuccess(false);
                                onClose();
                            }}
                            actionMessage="Job Status Updated Successfully!"

                        />
                    </div>
                </div>
            </>
        )
    );
};





export default JobStatusDialog